import React from 'react';

/** Rimuove lo splash HTML inline mostrato prima del mount React. */
function dismissHtmlBootSplash(): void {
  document.getElementById('boot-splash')?.remove();
}

/**
 * Placeholder: lo splash nativo Capacitor viene nascosto da SyncProgressOverlay
 * dopo il sync (o quando l'overlay non è visibile).
 */
export const AppReady: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  React.useEffect(() => {
    dismissHtmlBootSplash();
  }, []);

  return <>{children}</>;
};
